// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2n8YJ","content":"styles_content__1uA_h","selectAll":"styles_selectAll__1v6Qa"};